import styled from 'styled-components';
import { ReactSVG } from 'react-svg';

export const TitleIcon = styled(ReactSVG)`
  svg {
    width: 70px;
    height: auto;
  }

  margin-bottom: 10px;
`;

export const Title = styled.div`
  font-size: 22px;
  color: ${({ theme }) => theme.elements.textGrey};
  font-weight: 600;
  margin-bottom: 1.5rem;
`;

export const MessageContent = styled.div`
  margin-bottom: 2rem;
`;

export const MainMessage = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.base};
  color: ${({ theme }) => theme.colors.mediumGrey};
  margin-bottom: 1rem;
`;

export const BulletList = styled.ul`
  list-style: disc;
  margin-left: 1.5rem;
  padding: 0;
`;

export const BulletItem = styled.li`
  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.colors.mediumGrey};
  margin-bottom: 0.5rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`;
